import script from "./about-me-edit.vue?vue&type=script&setup=true&lang=js"
export * from "./about-me-edit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__